import { getJson, postJson, withOptional, withValidate, withDone } from '@rad/utility/http';
export const SCORECARD_BUILD_STATUSES = [
    'initial',
    // 'build-requested',
    // 'build-changes',
];
export const SCORECARD_TENTATIVE_STATUSES = [
// 'build-pending',
// 'approval-pending',
// 'approved',
];
export const SCORECARD_ALL_STATUSES = [
    ...SCORECARD_BUILD_STATUSES,
    ...SCORECARD_TENTATIVE_STATUSES,
    'live',
    'disabled',
    'frozen',
    'expired',
];
export const formatScorecardStatus = (x) => x.split('-').map((x) => `${x.substring(0, 1).toUpperCase()}${x.substring(1)}`).join(' ');
export const getScorecards = () => getJson('/api/scorecards');
export const getScorecard = (id) => withOptional(getJson(`/api/scorecards/${id}`));
export const createScorecard = (x) => withDone(withValidate(postJson('/api/scorecards', x)))();
export const updateScorecard = (x) => withDone(withValidate(postJson(`/api/scorecards/${x.id}`, x)))();
export const updateScorecardStatus = (x) => withDone(withValidate(postJson(`/api/scorecards/${x.id}/status`, x)))();
export const cloneScorecard = (x) => withDone(withValidate(postJson(`/api/scorecards/${x.id}/clone`, x)))();
export const approveScorecard = (x) => withDone(withValidate(postJson(`/api/scorecards/${x.id}/approve`, x)))();
